import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAccountStore } from '../../../../../components/Stores/accountStore';
import { ClientOrderQuote } from '../../../../../sp-types/clientOrderQuoteType';
import { MonthYearValue } from '../../../../../utils/MonthYear/MonthYearValue';
import { submitQuote } from '../../../ClientQuotesUtils';

interface Props {
  clientOrder: ClientOrderQuote;
  navigateToRefine: () => void;
  navigateToLegal: () => void;
  navigateToHandShake: () => void;
  quantity: number;
  setIsExposureLoading: (value: boolean) => void;
  priceCalender?: MonthYearValue[];
}

export const ClientOrderCompleteQuote: React.FC<Props> = ({
  clientOrder,
  navigateToHandShake,
  navigateToRefine,
  setIsExposureLoading,
}) => {
  const [orderStatusIndex] = useState(0);
  const [adding] = useState(1.37); // Need to be passed
  const [BasicPrice] = useState(2050); // Need to be passed
  const [addedPrice] = useState(28); // Need to be passed
  const [adjustedPrice] = useState(2022); // Need to be passed
  const [totalPrice] = useState(60_660_000); // Need to be passed
  const { account } = useAccountStore();

  const trafficStatus: TrafficStatusObject[] = [
    { text: 'Approval required', color: 'red-500' },
    { text: 'Additional details needed', color: 'yellow-500' },
    { text: 'Great! Ready to submit!', color: 'green-300' },
  ];

  const priceFields: componentTextFields[] = [
    { title: 'Basic price (unit)', value: `$${BasicPrice}`, color: 'black' },
    { title: 'Adding', value: `-${adding}%`, color: 'black' },
    { title: 'USD', value: `$${addedPrice.toFixed()}`, color: 'red' },
    { title: 'Adjusted price', value: `$${adjustedPrice.toFixed()}`, color: 'red' },
    { title: 'Quantity', value: `${clientOrder.quantity.toLocaleString()}`, color: 'black' },
    { title: 'Total adjusted price', value: `$${totalPrice.toLocaleString()}`, color: 'red' },
  ];

  const additionalDetailsFields: componentTextFields[] = [];
  clientOrder.downPayments && additionalDetailsFields.push({ title: 'Down payments', value: '10%', color: 'black' });
  clientOrder.changesFee && additionalDetailsFields.push({ title: 'Changes', value: 'No change - 3%', color: 'black' });
  clientOrder.cancellationFee &&
    additionalDetailsFields.push({ title: 'Cancellation', value: 'No cancellation 0%', color: 'black' });

  const actionButtons: ActionButton[] = [
    {
      Action: () => {
        navigateToRefine();
      },
      iconPath: '/assets/icons/colored/refine.svg',
      title: 'Refine',
      isDisabled: true,
    },
    {
      Action: () => {
        submitQuote(account.id || '', navigateToHandShake, setIsExposureLoading);
      },
      iconPath: '/assets/icons/colored/hand-shake.svg',
      title: 'Submit',
    },
    // {
    //   Action: () => {
    //     navigateToLegal();
    //   },
    //   iconPath: '/assets/icons/colored/legal.svg',
    //   title: 'Legal',
    // },
  ];

  return (
    <div className="flex  h-full mt-[3rem]">
      <div className="basis-1/3  space-y-[2.5rem] mt-[2.5rem] ps-[1.5rem] me-[1rem]  ">
        {trafficStatus.map((item, index) => (
          <div key={index} className="flex   text-center space-x-[1.25rem] ">
            <div
              className={`xl:h-[5rem] xl:w-[5rem]  lg:h-[4rem] lg:w-[4rem] md:h-[3rem] md:w-[3rem] sm:h-[3rem] sm:w-[3rem] aspect-square    border-2 border-${
                item.color
              }  rounded-full ${index === orderStatusIndex && `bg-${item.color}`}`}
            ></div>
            <p className={`my-auto  text-${index === orderStatusIndex ? 'black' : 'gray-700'} text-lg`}>{item.text}</p>
          </div>
        ))}
      </div>
      <div className="border-l border-gray-100 w-[2px] h-[90%]"></div>
      <div className="basis-2/3 flex flex-col xl:ps-[5rem] lg:ps-[2rem] md:ps-[2rem]  sm:ps-[2rem]   h-full">
        <div className="mb-[3rem] text-lg">Recommended price</div>
        <div className="flex flex-wrap space-x-[0.75rem] justify-between">
          {priceFields.map((item, index) => (
            <div key={index}>
              <p className="mb-[0.25rem] text-sm text-secondary_text">{item.title}</p>
              <p className={`text-${item.color}`}>{item.value}</p>
            </div>
          ))}
        </div>
        <div className="flex-wrap space-y-[1.5rem] ">
          {additionalDetailsFields.map((item, index) => (
            <div key={index}>
              <p className="mb-[0.25rem] text-sm text-secondary_text">{item.title}</p>
              <p className={`text-${item.color}`}>{item.value}</p>
            </div>
          ))}
        </div>
        <div className="flex mt-[3.75rem] space-x-[2.5rem] ">
          {actionButtons.map((item, index) => (
            <button
              key={item.title || index}
              onClick={item.isDisabled ? () => toast.info('unavailable in Demo mode') : item.Action}
              title={item.title}
              className={`aspect-square w-[5.625rem] justify-between border-purple text-purple  
          text-sm border-1 hover:bg-gray-50 py-[0]  rounded`}
            >
              <img title="refine" src={item.iconPath} className=" mx-auto aspect-square  h-[2rem]"></img>
              <div className="mt-[0.75rem]">{item.title}</div>
            </button>
          ))}
        </div>
        <div className=" flex flex-row pb-[5rem] "></div>
      </div>
    </div>
  );
};

type TrafficStatusObject = {
  text: string;
  color: string;
};

type componentTextFields = {
  title: string;
  value: string;
  color?: string;
};

type ActionButton = {
  title: string;
  iconPath: string;
  Action: (e: any) => void;
  isDisabled?: boolean;
};
